/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  '/api/auth/signout': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Sign out user
     * @description Sign out a user
     */
    post: operations['PostSignoutUser']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/buynow/create': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Create a buy now cart
     * @description Create a buy now cart
     */
    post: operations['PostCreateCart']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/buynow/calculator': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Create a buy now cart from needs
     * @description Create a buy now cart
     */
    post: operations['PostCalculateCart']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/companies/mine/nominalquantities': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get my company spools nominal quantities
     * @description Get my company spools nominal quantities
     */
    get: operations['GetCurrentCompanySpoolNominalQuantities']
    put?: never
    /**
     * Set my company spools nominal quantities
     * @description Set my company spools nominal quantities
     */
    post: operations['PostCurrentCompanySpoolNominalQuantities']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/devices': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get user devices
     * @description Get user devices
     */
    get: operations['GetDevices']
    put?: never
    /**
     * Create a device
     * @description Create a device
     */
    post: operations['PostDevice']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/devices/{deviceId}': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get a device by its id
     * @description Get a device by its id
     */
    get: operations['GetDeviceById']
    put?: never
    post?: never
    /**
     * Soft delete a device
     * @description Soft delete a device
     */
    delete: operations['DeleteDevice']
    options?: never
    head?: never
    /**
     * Update device info like name, position or firmware version
     * @description Update device info like name, position or firmware version
     */
    patch: operations['PatchDevice']
    trace?: never
  }
  '/api/devices/externalId/{externalId}': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get a device by its mac address
     * @description Get a device by its mac address
     */
    get: operations['GetDeviceByExternalId']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/devices/{deviceId}/pullsessions': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Add pull sessions to a device
     * @description Add pull sessions to a device
     */
    post: operations['PostDevicePullSessions']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/devices/{deviceId}/live': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Create a device snapshot
     * @description Create a device snapshot
     */
    post: operations['PostDeviceLive']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/devices/{deviceId}/stats': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get usage statistics for a device
     * @description Get usage statistics for a device
     */
    get: operations['GetDeviceStats']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/firmwares/latest': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get latest firmware info for device
     * @description Get latest firmware info for device
     */
    get: operations['GetLatestFirmware']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/firmwares/download': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get firmware file
     * @description Return firmware file
     */
    get: operations['DownloadFirmwareByVersion']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/firmwares': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Create new firmware in the system
     * @description Returns new firmware info
     */
    post: operations['PostFirmware']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/metadata/helpcontacts': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get help contact
     * @description Returns the help contact for the country provided in the mobiway-country header
     */
    get: operations['GetHelpContact']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/metadata/services': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get external service availability
     * @description Returns external service availability for the country provided in the mobiway-country header
     */
    get: operations['GetServices']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/packs/{packRef}': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get a pack by its reference
     * @description Get a pack by its reference
     */
    get: operations['GetPackByReference']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/pullsessions': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get pull sessions
     * @description Get pull sessions
     */
    get: operations['GetPullSessions']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/pullsessions/{pullSessionId}': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get a pull session details
     * @description Get a pull session details"
     */
    get: operations['GetPullSessionById']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    /**
     * Assign a site to a pull session or mark it as ignored
     * @description Update pull session
     */
    patch: operations['PatchPullSession']
    trace?: never
  }
  '/api/pullsessions/recompute-pulled-lengths': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Recompute all pulled lengths
     * @description Queue pulled length recomputation for all existing spools
     */
    post: operations['RecomputePulledLengths']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/users/me/refillalert': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get user current opened alert
     * @description Get user current opened alert
     */
    get: operations['GetCurrentRefillAlert']
    put?: never
    /**
     * Create a refill alert for user
     * @description Create a refill alert for user
     */
    post: operations['PostRefillAlert']
    /**
     * Delete all refill alert for user
     * @description Delete all refill alert for user
     */
    delete: operations['DeleteRefillAlert']
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/users/me/refillalert/{hash}': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    /**
     * Mark refill alert as used
     * @description Mark refill alert as used
     */
    patch: operations['PatchRefillAlert']
    trace?: never
  }
  '/api/sites': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get sites for user's company
     * @description Get sites for user's company
     */
    get: operations['GetSites']
    put?: never
    /**
     * Create a construction site
     * @description Create a construction site
     */
    post: operations['PostSite']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/sites/{siteId}': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get a site by its id
     * @description Get a site by its id
     */
    get: operations['GetSiteById']
    /**
     * Update a construction site
     * @description Update a construction site
     */
    put: operations['PutSite']
    post?: never
    /**
     * Delete a construction site
     * @description Delete a construction site
     */
    delete: operations['DeleteSite']
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/sites/{siteId}/stats': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get a site's statistics by its id
     * @description Get a site's statistics by its id
     */
    get: operations['GetSiteStatsById']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/sites/{siteId}/performance': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get a site's performance by its id
     * @description Get a site's performance by its id
     */
    get: operations['GetSitePerformanceById']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/sites/{siteId}/invitations': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Create an invitation to site
     * @description Create an invitation to site
     */
    post: operations['PostInvitation']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/sites/{siteId}/close': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    /**
     * Close a construction site
     * @description Close a construction site
     */
    patch: operations['CloseSite']
    trace?: never
  }
  '/api/sites/members': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Add a member to site via invitation
     * @description Add a member to site via invitation
     */
    post: operations['PostSiteMember']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/sites/{siteId}/members/me': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    post?: never
    /**
     * Remove connected user as member from site
     * @description Remove connected user as member from site
     */
    delete: operations['DeleteSiteMemberSelf']
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/spareparts': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get all spare parts
     * @description Get all spare parts
     */
    get: operations['GetSpareParts']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/spareparts/order': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Create a spare part order
     * @description Create a spare part order
     */
    post: operations['PostSparePartOrder']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/spools': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get user spools
     * @description Get user spools
     */
    get: operations['GetSpools']
    put?: never
    /**
     * Create spool in stock
     * @description Returns created spool
     */
    post: operations['PostSpool']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/spools/references': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get spool references
     * @description Get spool references
     */
    get: operations['GetSpoolReferences']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/spools/{spoolId}': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get a spool by its id
     * @description Get a spool by its id
     */
    get: operations['GetSpoolById']
    put?: never
    post?: never
    /**
     * Move spool to scrap
     * @description Move spool to scrap
     */
    delete: operations['DeleteSpool']
    options?: never
    head?: never
    /**
     * Patch remaining length of spool
     * @description Returns updated spool
     */
    patch: operations['PatchSpool']
    trace?: never
  }
  '/api/spools/scrap-recycling': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get potential value for scrap recycling
     * @description Get potential value for scrap recycling
     */
    get: operations['GetScrapRecycling']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/stats/pulled-length': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get pulled length statistics
     * @description Get daily, spool-reference, overall, and site-assigned pulled lengths for the connected user's company
     */
    get: operations['GetPulledLength']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/stats/sessions-count': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get pull sessions count and cumulated duration per day
     * @description Get, for each day with pull sessions for the connected user's company, the number of sessions and their cumulated duration
     */
    get: operations['GetSessionsCount']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/stats/used-spools': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get the number of used spools of the connected user's company
     * @description Get, for all spools owned by the connected user's company, the number of distinct spools used at least once, globally and per spool reference
     */
    get: operations['GetUsedSpools']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/stats/spools-lifetime': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get the average spools lifetime of the connected user's company
     * @description Get, for each spool reference owned by the connected user's company, the number of spools that reached end of life (RemainingLength below 3 meters) and their average lifetime
     */
    get: operations['GetSpoolsLifetime']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/stats/stock': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get spool stock additions count per day
     * @description Get, for each day with spools added to the connected user's company stock, the number of spools added, split by scan source (device or phone)
     */
    get: operations['GetStockAdditions']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/users/me': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get my account
     * @description Get requester informations
     */
    get: operations['GetCurrentUser']
    put?: never
    post?: never
    /**
     * Delete my account
     * @description Delete requester account
     */
    delete: operations['DeleteCurrentUser']
    options?: never
    head?: never
    /**
     * Patch my info
     * @description Patch requester informations
     */
    patch: operations['PatchCurrentUser']
    trace?: never
  }
}
export type webhooks = Record<string, never>
export interface components {
  schemas: {
    AddressSuggestion: {
      address: string
      /** Format: double */
      latitude: number
      /** Format: double */
      longitude: number
    }
    /**
     * @description Represents the audio language used by the device during cable-pulling operations.
     * @enum {string}
     */
    AudioLanguage: AudioLanguage
    AuthSessionDto: {
      /** Format: uuid */
      sessionId: string
    }
    /** @enum {string} */
    AvailableCountry: AvailableCountry
    /** @enum {string} */
    CableColor: CableColor
    /** @enum {string} */
    CableDiameter: CableDiameter
    CalculateCartCommand: {
      /** Format: int32 */
      surface: number
      /** Format: double */
      ceilingHeight: number
      /** Format: int32 */
      floorsNumber: number
      /** Format: int32 */
      roomsNumber: number
      /** Format: int32 */
      lightPointsNumber: number
      /** Format: int32 */
      outletsNumber: number
      /** Format: int32 */
      specificOutletsNumber: number
      heatingType: components['schemas']['CalculatorHeatingType']
    }
    /** @enum {string} */
    CalculatorHeatingType: CalculatorHeatingType
    CartDeviceReferenceResponse: {
      /** Format: uuid */
      id: string
      type: components['schemas']['DeviceType']
      imageUrl?: string | null
      /** Format: int32 */
      quantity: number
    }
    CartResponse: {
      spoolReferences: components['schemas']['CartSpoolReferenceResponse'][]
      deviceReferences: components['schemas']['CartDeviceReferenceResponse'][]
      carts: components['schemas']['CartRetailerResponse'][]
    }
    CartRetailerResponse: {
      /** Format: uuid */
      cartId: string
      reseller: components['schemas']['Reseller']
      canBeOrdered: boolean
    }
    CartSpoolReferenceResponse: {
      /** Format: uuid */
      id: string
      name: string
      imageUrl?: string | null
      internalRef: components['schemas']['SpoolInternalRef']
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /** Format: int32 */
      quantity: number
    }
    /** @enum {string} */
    Civility: Civility
    /** @enum {string} */
    CompanySize: CompanySize
    CompanySpoolNominalQuantityDto: {
      /** Format: uuid */
      spoolReferenceId: string
      name: string
      imageUrl?: string | null
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /** Format: int32 */
      quantity: number
    }
    CreateCartCommand: {
      spools: components['schemas']['CreateCartItem'][]
      devices: components['schemas']['CreateCartItem'][]
    }
    CreateCartItem: {
      /** Format: uuid */
      id: string
      /** Format: int32 */
      quantity: number
    }
    CreateCompanySpoolNominalQuantitiesCommand: {
      quantities: components['schemas']['CreateCompanySpoolNominalQuantitiesItem'][]
    }
    CreateCompanySpoolNominalQuantitiesItem: {
      /** Format: uuid */
      spoolReferenceId: string
      /** Format: int32 */
      quantity: number
    }
    CreateDeviceCommand: {
      externalId: string
      type: components['schemas']['DeviceType']
      manufacturerName: string
      modelNumber: string
      serialNumber: string
      firmwareVersion: string
      hardwareVersion: string
      audioLanguage: components['schemas']['AudioLanguage']
    }
    CreateDevicePullSessionsCommand: {
      /** Format: uuid */
      id: string
      pullSessions: components['schemas']['DevicePullSession'][]
    }
    CreateDeviceSnapshotCommand: {
      /** Format: uuid */
      deviceId: string
      slot1?: components['schemas']['CreateDeviceSnapshotSlot'] | null
      slot2?: components['schemas']['CreateDeviceSnapshotSlot'] | null
      slot3?: components['schemas']['CreateDeviceSnapshotSlot'] | null
    }
    CreateDeviceSnapshotSlot: {
      externalId: string
      /** Format: double */
      initialLength?: number | null
      /** Format: double */
      remainingLength: number
      cableColor?: components['schemas']['CableColor'] | null
      cableDiameter?: components['schemas']['CableDiameter'] | null
    }
    CreateFirmwareCommand: {
      type: components['schemas']['DeviceType']
      version: string
      file: components['schemas']['IFormFile']
      hardwareVersion: string
    }
    CreateSiteCommand: {
      name: string
      address?: string | null
      /** Format: double */
      latitude?: number | null
      /** Format: double */
      longitude?: number | null
      /** Format: date-time */
      startedOn: string
      description?: string | null
      isNew: boolean
      type: components['schemas']['SiteType']
      /** Format: int32 */
      surface: number
      /** Format: int32 */
      floorsNumber: number
      /** Format: int32 */
      roomsNumber: number
      heatingType: components['schemas']['HeatingType']
    }
    CreateSiteMemberCommand: {
      code: string
    }
    CreateSiteMemberResponse: {
      /** Format: uuid */
      siteId: string
    }
    CreateSparePartOrderCommand: {
      /** Format: uuid */
      sparePartId: string
      breakDescription: string
      image: components['schemas']['IFormFile']
      company: string
      address: string
      postalCode: string
      city: string
      phoneNumber: string
      mobilePhoneNumber?: string | null
      firstName: string
      lastName: string
    }
    CreateSpoolCommand: {
      externalId: string
      color: components['schemas']['CableColor']
      diameter: components['schemas']['CableDiameter']
      /** Format: double */
      initialLength: number
      /** Format: double */
      remainingLength: number
      scanSource: components['schemas']['SpoolScanSource']
    }
    CreateSpoolResponse: {
      alreadyInStock: boolean
      /** Format: uuid */
      id: string
      externalId: string
      name: string
      imageUrl?: string | null
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /** Format: double */
      remainingLength: number
      currentDevice?: components['schemas']['SpoolDeviceDto'] | null
      /** Format: date-time */
      deletedOn?: string | null
      /** Format: date-time */
      createdOn: string
      /** Format: date-time */
      updatedOn: string
    }
    /** @description Represents the pulled length for a single UTC day. */
    DailyPulledLengthDto: {
      /**
       * Format: date
       * @description Gets or sets the UTC day on which the pull sessions started.
       */
      day: string
      /**
       * Format: double
       * @description Gets or sets the total pulled length for the day.
       */
      pulledLength: number
    }
    /** @description Represents the pull-session aggregation for a single day. */
    DailySessionsCountDto: {
      /**
       * Format: date
       * @description Day (UTC) for which the pull sessions are aggregated.
       */
      day: string
      /**
       * Format: int32
       * @description Number of pull sessions started on DateOnly DailySessionsCountDto.Day for the company.
       */
      sessionsCount: number
      /**
       * Format: duration
       * @description Cumulated duration of the pull sessions of DateOnly DailySessionsCountDto.Day (sum of EndedOn - StartedOn).
       */
      cumulatedDuration: string
    }
    /** @description Represents the spool-stock-addition aggregation for a single day. */
    DailyStockAdditionsDto: {
      /**
       * Format: date
       * @description Day (UTC) for which the stock additions are aggregated.
       */
      day: string
      /**
       * Format: int32
       * @description Number of spools added to the company stock on DateOnly DailyStockAdditionsDto.Day via a device
       *     (SpoolScanSource.Device).
       */
      fromDeviceCount: number
      /**
       * Format: int32
       * @description Number of spools added to the company stock on DateOnly DailyStockAdditionsDto.Day via a phone
       *     (SpoolScanSource.Phone).
       */
      fromPhoneCount: number
    }
    DayPullLengthBySpoolReference: {
      /** Format: date */
      day: string
      spoolReferences?: components['schemas']['PullLengthBySpoolReference'][]
    }
    DeviceDetailsDto: {
      /** Format: uuid */
      id: string
      externalId: string
      name: string
      type: components['schemas']['DeviceType']
      lastPosition?: components['schemas']['DeviceDetailsLocationDto'] | null
      firmwareVersion: string
      /** Format: date-time */
      firmwareVersionUpdatedOn?: string | null
      lastLiveSlot1?: components['schemas']['DeviceDetailsSnapshotDto'] | null
      lastLiveSlot2?: components['schemas']['DeviceDetailsSnapshotDto'] | null
      lastLiveSlot3?: components['schemas']['DeviceDetailsSnapshotDto'] | null
      /** Format: date-time */
      lastLiveUpdatedOn: string
      manufacturerName: string
      modelNumber: string
      serialNumber: string
      hardwareVersion: string
      /** Format: date-time */
      createdOn: string
      /** Format: date-time */
      updatedOn: string
      audioLanguage: components['schemas']['AudioLanguage']
      statistics?: components['schemas']['DeviceStatsDto']
    }
    DeviceDetailsLocationDto: {
      address?: string | null
      /** Format: double */
      latitude: number
      /** Format: double */
      longitude: number
      /** Format: date-time */
      updatedOn: string
    }
    DeviceDetailsSnapshotDto: {
      externalId: string
      /** Format: double */
      remainingLength: number
      spoolReference?: components['schemas']['DeviceDetailsSpoolReferenceDto'] | null
    }
    DeviceDetailsSpoolReferenceDto: {
      /** Format: uuid */
      id: string
      name: string
      imageUrl?: string | null
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
    }
    DevicePullSession: {
      externalId: string
      /** Format: double */
      initialLength: number
      /** Format: double */
      remainingLength: number
      color: components['schemas']['CableColor']
      diameter: components['schemas']['CableDiameter']
      /** Format: int32 */
      sequenceId: number
      /** Format: date-time */
      firstSeenDate: string
      /** Format: date-time */
      lastSeenDate: string
      /** Format: double */
      unwindingDuration: number
    }
    DeviceStatsDto: {
      /** Format: double */
      totalLength: number
      lengthByReference?: components['schemas']['DeviceStatsPerReferenceDto'][]
    }
    DeviceStatsPerReferenceDto: {
      /** Format: uuid */
      id: string
      nameKey: string
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /** Format: double */
      totalLength: number
    }
    /** @enum {string} */
    DeviceType: DeviceType
    DownloadFirmwareByVersionResponse: {
      /** Format: byte */
      content: string
      fileName: string
    }
    ExceptionDetails: {
      message?: string | null
      errors?: components['schemas']['ValidationErrorDto'][] | null
      stackTrace?: string[] | null
      exceptionType?: string | null
      requestId?: string | null
    }
    FirmwareDetailsDto: {
      type: components['schemas']['DeviceType']
      version: string
      /** Format: date-time */
      createdOn: string
      hardwareVersion: string
    }
    GetAddressSuggestionsResponse: {
      suggestions: components['schemas']['AddressSuggestion'][]
    }
    /** @description Represents pulled-length aggregations for the connected user's company. */
    GetPulledLengthResponse: {
      /** @description Gets or sets pulled lengths grouped by the UTC day on which each pull session started. */
      dailyPulledLengths?: components['schemas']['DailyPulledLengthDto'][]
      /** @description Gets or sets pulled lengths grouped by spool reference. */
      spoolReferencePulledLengths?: components['schemas']['SpoolReferencePulledLengthDto'][]
      /**
       * Format: double
       * @description Gets or sets the pulled length across all included pull session items.
       */
      totalPulledLength: number
      /**
       * Format: double
       * @description Gets or sets the pulled length from included pull sessions assigned to a site.
       */
      sitePulledLength: number
    }
    GetScrapRecyclingResponse: {
      /** Format: double */
      totalLength: number
      /** Format: double */
      potentialValue: number
    }
    GetSitePerformanceByIdResponse: {
      /** Format: double */
      pulledLength: number
      /** Format: double */
      comparedAverageLength?: number | null
      /** Format: int32 */
      comparedSitesCount: number
      detailsPerDay?: components['schemas']['DayPullLengthBySpoolReference'][]
    }
    GetSitesResponse: {
      /** Format: uuid */
      id: string
      name: string
      type: components['schemas']['SiteType']
      /** Format: double */
      pulledDistance: number
      /** Format: date-time */
      lastActivityOn?: string | null
      /** Format: date-time */
      closedOn?: string | null
      /** Format: date-time */
      createdOn: string
    }
    GetSiteStatsByIdResponse: {
      /** Format: duration */
      pullDuration: string
      /** Format: double */
      pullLength: number
      cables: components['schemas']['StatisticsByCable'][]
    }
    GetSparePartsResponse: {
      /** Format: uuid */
      id: string
      name: string
      imageUrl?: string | null
      deviceType: components['schemas']['DeviceType']
    }
    GetSpoolsLifetimeResponse: {
      /** @description Average lifetime aggregation, one entry per spool reference having at least one end-of-life spool. */
      spoolsLifetimes?: components['schemas']['SpoolLifetimeDto'][]
    }
    GetUsedSpoolsResponse: {
      /**
       * Format: int32
       * @description Number of distinct company spools used at least once (non-zero pulled length on at least one pull session item).
       */
      totalUsedSpools: number
      /**
       * @description Number of distinct used spools per spool reference.
       *     Only references with at least one used spool are returned.
       */
      usedSpoolsByReference?: components['schemas']['UsedSpoolsByReferenceDto'][]
    }
    /** @enum {string} */
    HeatingType: HeatingType
    HelpContactDto: {
      email?: string | null
      phoneNumber?: string | null
    }
    /** Format: binary */
    IFormFile: string
    /** @enum {string} */
    Language: Language
    PackDetailsDto: {
      internalRef: components['schemas']['PackInternalRef']
      country: components['schemas']['AvailableCountry']
      spoolReferences: components['schemas']['PackSpoolReferenceDto'][]
      deviceReferences: components['schemas']['PackDeviceReferenceDto'][]
    }
    PackDeviceReferenceDto: {
      /** Format: uuid */
      id: string
      type: components['schemas']['DeviceType']
      name: string
      nexansId: string
      eanCode: string
      gtinCode: string
      imageUrl?: string | null
      /** Format: int32 */
      quantity: number
    }
    /** @enum {string} */
    PackInternalRef: PackInternalRef
    PackSpoolReferenceDto: {
      /** Format: uuid */
      id: string
      internalRef: components['schemas']['SpoolInternalRef']
      nexansId: string
      eanCode?: string | null
      gtinCode?: string | null
      name: string
      imageUrl?: string | null
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /** Format: int32 */
      quantity: number
      countries?: components['schemas']['AvailableCountry'][]
    }
    PatchCurrentUserCommand: {
      fcmToken?: string | null
      companyName?: string | null
      companySize?: components['schemas']['CompanySize'] | null
      companyAddress?: string | null
      phoneNumber?: string | null
      civility?: components['schemas']['Civility'] | null
      lastName?: string | null
      firstName?: string | null
      preferredLanguage?: components['schemas']['Language'] | null
      hasConsentedMarketing?: boolean | null
      preferredStore?: components['schemas']['AvailableCountry'] | null
    }
    PatchDeviceCommand: {
      /** Format: uuid */
      id: string
      name?: string | null
      /** Format: double */
      latitude?: number | null
      /** Format: double */
      longitude?: number | null
      /** Format: double */
      altitude?: number | null
      firmwareVersion?: string | null
      audioLanguage?: components['schemas']['AudioLanguage'] | null
    }
    PatchPullSessionCommand: {
      /** Format: uuid */
      id: string
      /** Format: uuid */
      siteId?: string | null
      ignore?: boolean | null
    }
    PatchSpoolCommand: {
      /** Format: uuid */
      id: string
      /** Format: double */
      remainingLength: number
    }
    PhoneCodeDto: {
      country: string
      code: string
    }
    PullLengthBySpoolReference: {
      /** Format: uuid */
      spoolReferenceId: string
      name?: string | null
      cableColor?: components['schemas']['CableColor'] | null
      cableDiameter?: components['schemas']['CableDiameter'] | null
      /** Format: double */
      length: number
    }
    PullSessionDetailsDto: {
      /** Format: uuid */
      id: string
      /** Format: date-time */
      startedOn: string
      /** Format: date-time */
      endedOn: string
      /** Format: double */
      totalLength: number
      /** Format: uuid */
      deviceId: string
      spools: components['schemas']['PullSessionSpoolDto'][]
    }
    PullSessionDto: {
      /** Format: uuid */
      id: string
      /** Format: date-time */
      startedOn: string
      /** Format: date-time */
      endedOn: string
      /** Format: double */
      totalLength: number
      /** Format: uuid */
      deviceId: string
    }
    PullSessionSpoolDto: {
      /** Format: uuid */
      id: string
      externalId?: string | null
      name?: string | null
      imageUrl?: string | null
      /** Format: double */
      initialLength?: number | null
      cableColor?: components['schemas']['CableColor'] | null
      cableDiameter?: components['schemas']['CableDiameter'] | null
      /** Format: double */
      remainingLength?: number | null
      /** Format: date-time */
      deletedOn?: string | null
      /** Format: date-time */
      createdOn: string
      /** Format: date-time */
      updatedOn: string
      /** Format: double */
      pulledLength: number
    }
    RefillAlertResponse: {
      /** Format: uuid */
      id: string
      /** Format: date-time */
      expectedSendDate: string
    }
    RefreshUserTokenCommand: {
      refreshToken: string
    }
    RegisterUserCommand: {
      email: string
      companyName: string
      companySize: components['schemas']['CompanySize']
      companyAddress: string
      phoneNumber: string
      civility: components['schemas']['Civility']
      lastName: string
      firstName: string
      preferredLanguage: components['schemas']['Language']
      hasConsentedMarketing: boolean
      preferredStore?: components['schemas']['AvailableCountry'] | null
    }
    /** @enum {string} */
    Reseller: Reseller
    ResendUserActivationCommand: {
      /** Format: uuid */
      sessionId: string
    }
    /** @enum {string} */
    Role: Role
    ServicesAvailabilityDto: {
      cableLoop: boolean
      calculator: boolean
      easyProtect: boolean
      spareParts: boolean
    }
    SigninUserCommand: {
      email: string
    }
    SiteDetailsDto: {
      /** Format: uuid */
      id: string
      name: string
      address: string
      /** Format: double */
      longitude?: number | null
      /** Format: double */
      latitude?: number | null
      /** Format: date-time */
      startedOn: string
      /** Format: date-time */
      closedOn?: string | null
      /** Format: date-time */
      lastActivityOn?: string | null
      description?: string | null
      isNew: boolean
      type: components['schemas']['SiteType']
      /** Format: int32 */
      surface: number
      /** Format: int32 */
      floorsNumber: number
      /** Format: int32 */
      roomsNumber: number
      heatingType: components['schemas']['HeatingType']
      devices: components['schemas']['SiteDeviceDto'][]
      members: components['schemas']['SiteMemberDto'][]
    }
    SiteDeviceDto: {
      /** Format: uuid */
      id: string
      name: string
    }
    SiteInvitationDto: {
      code: string
    }
    SiteMemberDto: {
      /** Format: uuid */
      id: string
      firstName: string
      lastName: string
    }
    /** @enum {string} */
    SiteType: SiteType
    SpoolDetailsDto: {
      /** Format: uuid */
      id: string
      externalId: string
      name: string
      imageUrl?: string | null
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /** Format: double */
      remainingLength: number
      currentDevice?: components['schemas']['SpoolDeviceDto'] | null
      /** Format: date-time */
      deletedOn?: string | null
      /** Format: date-time */
      createdOn: string
      /** Format: date-time */
      updatedOn: string
    }
    SpoolDeviceDto: {
      /** Format: uuid */
      id: string
      name: string
      /** Format: int32 */
      slot: number
    }
    /** @enum {string} */
    SpoolInternalRef: SpoolInternalRef
    /** @description Average lifetime aggregation for a spool reference (color/diameter/initial length combination). */
    SpoolLifetimeDto: {
      color: components['schemas']['CableColor']
      diameter: components['schemas']['CableDiameter']
      /**
       * Format: double
       * @description Initial length of the spool reference (see `SpoolReference.InitialLength`).
       */
      initialLength: number
      /**
       * Format: int32
       * @description Number of spools of this reference that reached end of life (RemainingLength dropped below 3 meters).
       */
      endOfLifeSpoolsCount: number
      /**
       * Format: duration
       * @description Average lifetime of the spools of this reference that reached end of life.
       *     For each spool, the lifetime is the difference between the StartedOn of its very first pull-session item
       *     and the EndedOn of the first pull-session item for which RemainingLength dropped below 3 meters.
       */
      averageLifetime: string
    }
    SpoolReferenceDto: {
      /** Format: uuid */
      id: string
      name: string
      imageUrl?: string | null
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      countries?: components['schemas']['AvailableCountry'][]
    }
    /** @description Represents the pulled length for a spool reference. */
    SpoolReferencePulledLengthDto: {
      /**
       * Format: uuid
       * @description Gets or sets the spool reference identifier.
       */
      id: string
      /** @description Gets or sets the spool reference name key. */
      name?: string
      color: components['schemas']['CableColor']
      diameter: components['schemas']['CableDiameter']
      /**
       * Format: double
       * @description Gets or sets the initial length of the spool reference.
       */
      initialLength: number
      /**
       * Format: double
       * @description Gets or sets the total pulled length for the spool reference.
       */
      pulledLength: number
    }
    /** @enum {string} */
    SpoolScanSource: SpoolScanSource
    StatisticsByCable: {
      name?: string | null
      cableColor?: components['schemas']['CableColor'] | null
      cableDiameter?: components['schemas']['CableDiameter'] | null
      /** Format: double */
      length: number
    }
    TransferCartCommand: {
      /** Format: uuid */
      retailerCartId: string
      items?: components['schemas']['TransferCartItem'][] | null
      reseller: components['schemas']['Reseller']
    }
    TransferCartItem: {
      /** Format: uuid */
      id: string
      /** Format: int32 */
      quantity: number
    }
    TransferCartResponse: {
      /** Format: uuid */
      retailerCartId: string
      isSuccess: boolean
      method: string
      actionUrl: string
      body?: {
        [key: string]: string
      } | null
      textPlain?: string | null
    }
    UpdateSiteCommand: {
      /** Format: uuid */
      id: string
      name: string
      address?: string | null
      /** Format: double */
      latitude?: number | null
      /** Format: double */
      longitude?: number | null
      /** Format: date-time */
      startedOn: string
      description?: string | null
      isNew: boolean
      type: components['schemas']['SiteType']
      /** Format: int32 */
      surface: number
      /** Format: int32 */
      floorsNumber: number
      /** Format: int32 */
      roomsNumber: number
      heatingType: components['schemas']['HeatingType']
    }
    /** @description Number of distinct used spools for a given spool reference, along with the reference characteristics. */
    UsedSpoolsByReferenceDto: {
      /** @description Name of the spool reference (see `SpoolReference.NameKey`). */
      name?: string
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /**
       * Format: double
       * @description Initial length of the spool reference (see `SpoolReference.InitialLength`).
       */
      initialLength: number
      /**
       * Format: int32
       * @description Number of distinct spools of this reference used at least once.
       */
      count: number
    }
    UserDetailsCompanyDto: {
      /** Format: uuid */
      id: string
      name: string
      size: components['schemas']['CompanySize']
      address: string
    }
    UserDetailsDto: {
      /** Format: uuid */
      id: string
      role: components['schemas']['Role']
      company: components['schemas']['UserDetailsCompanyDto']
      civility: components['schemas']['Civility']
      firstName: string
      lastName: string
      email: string
      phoneNumber: string
      preferredLanguage: components['schemas']['Language']
      hasConsentedMarketing: boolean
      preferredStore: components['schemas']['AvailableCountry']
    }
    UserTokenDto: {
      idToken: string
      accessToken: string
      refreshToken: string
      /** Format: int32 */
      expiresIn?: number | null
    }
    ValidationErrorDto: {
      errorCode: string
      comparisonValues?: unknown[] | null
      attemptedValue?: unknown
      propertyName?: string
    }
    VerifyUserCommand: {
      /** Format: uuid */
      sessionId: string
      code: string
    }
  }
  responses: never
  parameters: never
  requestBodies: never
  headers: never
  pathItems: never
}
export type $defs = Record<string, never>
export interface operations {
  PostSignoutUser: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown
        }
        content?: never
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PostCreateCart: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateCartCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['CartResponse']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PostCalculateCart: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['CalculateCartCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['CartResponse']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetCurrentCompanySpoolNominalQuantities: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['CompanySpoolNominalQuantityDto'][]
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PostCurrentCompanySpoolNominalQuantities: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateCompanySpoolNominalQuantitiesCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['CompanySpoolNominalQuantityDto'][]
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetDevices: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['DeviceDetailsDto'][]
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PostDevice: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateDeviceCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['DeviceDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetDeviceById: {
    parameters: {
      query?: never
      header?: never
      path: {
        deviceId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['DeviceDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  DeleteDevice: {
    parameters: {
      query?: never
      header?: never
      path: {
        deviceId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown
        }
        content?: never
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PatchDevice: {
    parameters: {
      query?: never
      header?: never
      path: {
        deviceId: string
      }
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['PatchDeviceCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['DeviceDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetDeviceByExternalId: {
    parameters: {
      query?: never
      header?: never
      path: {
        externalId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['DeviceDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PostDevicePullSessions: {
    parameters: {
      query?: never
      header?: never
      path: {
        deviceId: string
      }
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateDevicePullSessionsCommand']
      }
    }
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['DeviceDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PostDeviceLive: {
    parameters: {
      query?: never
      header?: never
      path: {
        deviceId: string
      }
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateDeviceSnapshotCommand']
      }
    }
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown
        }
        content?: never
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetDeviceStats: {
    parameters: {
      query?: never
      header?: never
      path: {
        deviceId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['DeviceStatsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetLatestFirmware: {
    parameters: {
      query?: {
        type?: components['schemas']['DeviceType']
        hardwareVersion?: string
      }
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['FirmwareDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  DownloadFirmwareByVersion: {
    parameters: {
      query: {
        version: string
        hardwareVersion: string
        type: components['schemas']['DeviceType']
      }
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['DownloadFirmwareByVersionResponse']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PostFirmware: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['CreateFirmwareCommand']
      }
    }
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['FirmwareDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetHelpContact: {
    parameters: {
      query?: never
      header?: {
        'Mobiway-Country'?: components['schemas']['AvailableCountry']
      }
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['HelpContactDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetServices: {
    parameters: {
      query?: never
      header?: {
        'Mobiway-Country'?: components['schemas']['AvailableCountry']
      }
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ServicesAvailabilityDto']
        }
      }
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetPackByReference: {
    parameters: {
      query?: never
      header?: {
        'Mobiway-Country'?: components['schemas']['AvailableCountry']
      }
      path: {
        packRef: components['schemas']['PackInternalRef']
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['PackDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetPullSessions: {
    parameters: {
      query?: {
        unaffected?: boolean
      }
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['PullSessionDto'][]
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetPullSessionById: {
    parameters: {
      query?: never
      header?: never
      path: {
        pullSessionId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['PullSessionDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PatchPullSession: {
    parameters: {
      query?: never
      header?: never
      path: {
        pullSessionId: string
      }
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['PatchPullSessionCommand']
      }
    }
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown
        }
        content?: never
      }
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  RecomputePulledLengths: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description Accepted */
      202: {
        headers: {
          [name: string]: unknown
        }
        content?: never
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetCurrentRefillAlert: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['RefillAlertResponse']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PostRefillAlert: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content?: never
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  DeleteRefillAlert: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown
        }
        content?: never
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PatchRefillAlert: {
    parameters: {
      query?: never
      header?: never
      path: {
        hash: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown
        }
        content?: never
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetSites: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['GetSitesResponse'][]
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PostSite: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSiteCommand']
      }
    }
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['SiteDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetSiteById: {
    parameters: {
      query?: never
      header?: never
      path: {
        siteId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['SiteDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PutSite: {
    parameters: {
      query?: never
      header?: never
      path: {
        siteId: string
      }
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateSiteCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['SiteDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  DeleteSite: {
    parameters: {
      query?: never
      header?: never
      path: {
        siteId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['SiteDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetSiteStatsById: {
    parameters: {
      query?: never
      header?: never
      path: {
        siteId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['GetSiteStatsByIdResponse']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetSitePerformanceById: {
    parameters: {
      query?: never
      header?: never
      path: {
        siteId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['GetSitePerformanceByIdResponse']
        }
      }
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PostInvitation: {
    parameters: {
      query?: never
      header?: never
      path: {
        siteId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['SiteInvitationDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  CloseSite: {
    parameters: {
      query?: never
      header?: never
      path: {
        siteId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['SiteDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PostSiteMember: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSiteMemberCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['CreateSiteMemberResponse']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  DeleteSiteMemberSelf: {
    parameters: {
      query?: never
      header?: never
      path: {
        siteId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown
        }
        content?: never
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetSpareParts: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['GetSparePartsResponse'][]
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PostSparePartOrder: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['CreateSparePartOrderCommand']
      }
    }
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown
        }
        content?: never
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetSpools: {
    parameters: {
      query?: {
        isScrapped?: boolean
      }
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['SpoolDetailsDto'][]
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PostSpool: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSpoolCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['CreateSpoolResponse']
        }
      }
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['CreateSpoolResponse']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetSpoolReferences: {
    parameters: {
      query?: {
        search?: string
      }
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['SpoolReferenceDto'][]
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetSpoolById: {
    parameters: {
      query?: never
      header?: never
      path: {
        spoolId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['SpoolDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  DeleteSpool: {
    parameters: {
      query?: never
      header?: never
      path: {
        spoolId: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['CreateSpoolResponse']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PatchSpool: {
    parameters: {
      query?: never
      header?: never
      path: {
        spoolId: string
      }
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['PatchSpoolCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['SpoolDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetScrapRecycling: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['GetScrapRecyclingResponse']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetPulledLength: {
    parameters: {
      query?: {
        siteIds?: string[]
      }
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['GetPulledLengthResponse']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetSessionsCount: {
    parameters: {
      query?: {
        siteIds?: string[]
      }
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['DailySessionsCountDto'][]
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetUsedSpools: {
    parameters: {
      query?: {
        siteIds?: string[]
      }
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['GetUsedSpoolsResponse']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetSpoolsLifetime: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['GetSpoolsLifetimeResponse']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetStockAdditions: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['DailyStockAdditionsDto'][]
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetCurrentUser: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['UserDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  DeleteCurrentUser: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown
        }
        content?: never
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  PatchCurrentUser: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['PatchCurrentUserCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['UserDetailsDto']
        }
      }
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
}
export enum AudioLanguage {
  Bip = 'Bip',
  French = 'French',
  English = 'English',
  German = 'German',
  Spanish = 'Spanish',
  Arabic = 'Arabic',
  Portuguese = 'Portuguese',
  Italian = 'Italian',
  Dutch = 'Dutch',
  Max = 'Max',
  Unknown = 'Unknown',
}
export enum AvailableCountry {
  FR = 'FR',
  CO = 'CO',
}
export enum CableColor {
  Unknown = 'Unknown',
  Blue = 'Blue',
  YellowGreen = 'YellowGreen',
  Red = 'Red',
  Black = 'Black',
  Purple = 'Purple',
  Orange = 'Orange',
  Yellow = 'Yellow',
  Green = 'Green',
  White = 'White',
  Gray = 'Gray',
  Brown = 'Brown',
}
export enum CableDiameter {
  Unknown = 'Unknown',
  Section1_5 = 'Section1_5',
  Section2_5 = 'Section2_5',
  Section12AWG = 'Section12AWG',
  Section14AWG = 'Section14AWG',
}
export enum CalculatorHeatingType {
  ElectricRadiator = 'ElectricRadiator',
  HeatPump = 'HeatPump',
  Boiler = 'Boiler',
}
export enum Civility {
  Mr = 'Mr',
  Mrs = 'Mrs',
}
export enum CompanySize {
  SelfEmployed = 'SelfEmployed',
  Micro = 'Micro',
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}
export enum DeviceType {
  POP = 'POP',
  MOB = 'MOB',
}
export enum HeatingType {
  ElectricRadiator = 'ElectricRadiator',
  HeatPump = 'HeatPump',
  Boiler = 'Boiler',
  NoHeating = 'NoHeating',
}
export enum Language {
  FR = 'FR',
  EN = 'EN',
  ES = 'ES',
  AR = 'AR',
  PT = 'PT',
  IT = 'IT',
  DE = 'DE',
  NL = 'NL',
}
export enum PackInternalRef {
  Simple = 'Simple',
  StarterSimple = 'StarterSimple',
  StarterDouble = 'StarterDouble',
  Spools3 = 'Spools3',
  Spools9 = 'Spools9',
}
export enum Reseller {
  Rexel = 'Rexel',
  Sonepar = 'Sonepar',
  Tereva = 'Tereva',
}
export enum Role {
  User = 'User',
  Administrator = 'Administrator',
}
export enum SiteType {
  Residential = 'Residential',
  Working = 'Working',
  Public = 'Public',
  HighRise = 'HighRise',
  Mixed = 'Mixed',
}
export enum SpoolInternalRef {
  GreenYellow25L100 = 'GreenYellow25L100',
  Blue25L100 = 'Blue25L100',
  Red25L100 = 'Red25L100',
  GreenYellow15L100 = 'GreenYellow15L100',
  Blue15L100 = 'Blue15L100',
  Red15L100 = 'Red15L100',
  Purple15L100 = 'Purple15L100',
  Orange15L100 = 'Orange15L100',
  Black15L100 = 'Black15L100',
  White15L100 = 'White15L100',
  Gray15L100 = 'Gray15L100',
  Brown15L100 = 'Brown15L100',
  Green12AWGL100 = 'Green12AWGL100',
  Red12AWGL100 = 'Red12AWGL100',
  Black12AWGL100 = 'Black12AWGL100',
  White12AWGL100 = 'White12AWGL100',
  Blue12AWGL100 = 'Blue12AWGL100',
  Yellow12AWGL100 = 'Yellow12AWGL100',
  Green14AWGL100 = 'Green14AWGL100',
  Red14AWGL100 = 'Red14AWGL100',
  Black14AWGL100 = 'Black14AWGL100',
  White14AWGL100 = 'White14AWGL100',
  Blue14AWGL100 = 'Blue14AWGL100',
  Yellow14AWGL100 = 'Yellow14AWGL100',
  Blue25L150 = 'Blue25L150',
  Red15L150 = 'Red15L150',
}
export enum SpoolScanSource {
  Phone = 'Phone',
  Device = 'Device',
}
